import type { GetContractsResponse } from '@vy/api-definition';
import { BILLING_INTERVALS, CONTRACT_STATUSES, PAYMENT_TERMS } from '@vy/types';
import type { ItemOf } from '@vy/utils';

export type ContractRow = ItemOf<GetContractsResponse['contracts']>;

export type PendingExtractionRow = ContractRow & {
  __isPendingExtraction: true;
  __filename: string;
};

type ActiveExtractionTask = {
  id: string;
  filename: string;
};

export function isPendingExtractionRow(row: ContractRow | PendingExtractionRow): row is PendingExtractionRow {
  return '__isPendingExtraction' in row && row.__isPendingExtraction === true;
}

export function buildPendingExtractionRow(task: ActiveExtractionTask): PendingExtractionRow {
  const placeholder: PendingExtractionRow = {
    __isPendingExtraction: true,
    __filename: task.filename,
    id: `pending-extraction-${task.id}`,
    createdAt: new Date(0),
    updatedAt: new Date(0),
    status: CONTRACT_STATUSES.InReview,
    startDate: new Date(0),
    initialStartDate: undefined,
    revisedAt: undefined,
    endDate: undefined,
    integrationEntities: [],
    signatureDate: undefined,
    customFieldValues: [],
    isEditable: false,
    revenue: 0,
    customer: {
      id: '',
      name: '',
      settings: null,
    },
    plan: {
      id: '',
      name: '',
      billingData: {
        billingInterval: BILLING_INTERVALS.Monthly,
        paymentTerm: PAYMENT_TERMS.Postpayment,
        duration: -1,
        autoRenewal: false,
      },
      products: [],
    },
  };

  return placeholder;
}
